import { ReactNode } from "react"
import { Link } from "react-router"

interface LinkButtonProps {
	children?: ReactNode
	className?: string
	to?: string
	onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
	selected?: boolean
}

function LinkButton({ children, to = "", onClick = undefined, className = "", selected = true }: LinkButtonProps) {

	if (onClick) return <button
		className={'px-2 py-1 rounded-lg ' + (selected ?
			'text-white bg-primary hover:bg-primaryGradient active:[background-image:none] active:bg-darkPrimary '
			: 'text-onBackground bg-darkForeground hover:bg-foreground ') + className}
		children={children}
		onClick={onClick}
	/>

	return <Link
		draggable={false}
		to={to}
		className={'px-2 py-1 rounded-lg ' + (selected ?
			'text-white bg-primary hover:bg-primaryGradient active:[background-image:none] active:bg-darkPrimary '
			: 'text-onBackground bg-darkForeground hover:bg-foreground ') + className}
		children={children}
	/>
}

export default LinkButton